// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"banner-background_wrapper__hiGwz"};